const win: any = window;
const lang = win['lang']
const rtl = (lang === "ar")
export const formModal = (changeFields: any, disabled: Boolean, t: any, submitForm: any) => {


    return {
      name: "getTicketForm",
      title: t("Check_Complaint/Request_Status"),
      titleClass: "",
      subTitle: t("please_enter_your_complaint"),
      subTitleClass: "mb-5 info-sub-title",
      id: "getInfoForm",
      captcha: true,
      captchaKey: "6LeDEBAaAAAAALpUmENFbnG_Kc-cN0H_Gch4BpRf",
      formClass: "custom-rich-text mb-5",
      changeFields: changeFields,
      formClassName: 'modal-form-dynamic-container',
      badgePosition: rtl ? 'bottomleft': 'bottomright',
      size: 'invisible',
      rows: [

        {
          rowClass: "row",
          cols: [
            {
              label: t("Ticket_number_*"),
              type: "text",
              maxLength: 255,
              tip: '',
              tipClass: "",
              colClass: "col-md-4 col-sm-4 px-3",
              itemName: "srNumber",
              colItemRules: [
                { required: true, message: t("required") },
             
              ],
            },
          ],
        },
        {
          rowClass: "row",
          cols: [
            {
              label: t("ID_number_*"),
              type: "text",
              maxLength: 255,
              tip: '',
              tipClass: "",
              colClass: "col-md-4 col-sm-4 px-3",
              itemName: "idNumber",
              colItemRules: [
                { required: true, message: t("idnumber_missing")},
        
              ],
            },
          ],
        },

        {
          rowClass: "row pt-4",
          cols: [
            {
              buttonClass: " text-uppercase w-75",
              buttonText: t("Find"),
              colClass: rtl ? "col-md-4 col-sm-12 mt-5 px-3 text-right" : "col-md-4 col-sm-12 mt-5 px-3",
              itemName: "submitbutton",
              type: "button",
              disabled: disabled,
              buttonAction: submitForm,
            },
          ],
        },
      ],
    };

  }